import { render, staticRenderFns } from "./TemplateButton.vue?vue&type=template&id=10f33a62&"
import script from "./TemplateButton.vue?vue&type=script&lang=js&"
export * from "./TemplateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports